/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';



const Form = () => {

  return (
    <Box>
      <Box marginBottom={4}>
        
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
          }}
        >
          Student Cornor
        </Typography>
      </Box>
    </Box>
  );
};

export default Form;
